import { useState, useEffect } from "react";
import { fetchPresignedUrlImage } from "services/filesRequests";
import { FetchPresignedUrlImageType } from "utils/interfaces";

/**
 * /**
 * Hook used to get an image by using a url to get a
 * presigned URL when rendering a component
 * @param src Source of the image (URL addresss used to get the presigned URL for fetching the image, or base64 format).
 * @param dependencies (Optional) Dependencies used to trigger the `useEffect` statement.
 * @param includeBackendUrl (Optional) Boolean to decide if include the backend URL automatically.
 * @returns
 */
const useGetImageByPresignedUrl = (
  src: string,
  dependencies: any[] = [],
  includeBackendUrl: boolean = true,
): [
  image: string | ArrayBuffer | null | undefined,
  state: FetchPresignedUrlImageType,
] => {
  // State for the image
  const [state, setState] = useState<FetchPresignedUrlImageType>("loading");
  const [image, setImage] = useState<string | ArrayBuffer | null | undefined>(
    null,
  );

  useEffect(() => {
    // Check if the image is not already loaded as base64 format
    if (src.startsWith("data:image/")) {
      setImage(src);
      setState("successful");
      return;
    }

    // Get the presigned URL
    fetchPresignedUrlImage(src, includeBackendUrl).then(
      (response) => {
        // If everything goes well, set the image as response
        setImage(response);
        setState("successful");
      },
      () => {
        setState("not-found");
      },
    );
  }, [...dependencies]);

  return [image, state];
};

export default useGetImageByPresignedUrl;
